import axios from 'axios'
import { AuthenticatedQuery, PSAQuery } from '../../interfaces/PaginatedQuery'

export interface ListCustomersParams {
  first_name?: string
  last_name?: string
  fiscal_code?: string
  company?: string
  csv?: boolean
}

export const list = async ({
  token,
  ...params
}: PSAQuery<ListCustomersParams> = {}) => {
  const response = await axios({
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/customers`,
    headers: {
      Authorization: `Bearer ${token}`
    },
    params: params
  })

  if (response instanceof Error) {
    throw new Error(response.message)
  }

  return response.data
}

interface GetCustomerParams {
  id: string
}

export const get = async ({
  id,
  token
}: AuthenticatedQuery<GetCustomerParams>) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/customers/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    if (response instanceof Error) {
      return { error: response }
    }

    return response
  } catch (error) {
    // Sentry TODO
    return { error }
  }
}

interface CreateCustomerParams {
  data: any
}

export const create = async ({
  data,
  token
}: AuthenticatedQuery<CreateCustomerParams>) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/customers`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data
    })

    if (response instanceof Error) {
      return { error: response }
    }

    return response
  } catch (error) {
    // Sentry TODO
    return { error }
  }
}

interface UpdateCustomerParams {
  id: string
  data: any
}

export const save = async ({
  id,
  data,
  token
}: AuthenticatedQuery<UpdateCustomerParams>) => {
  try {
    const response = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_API_URL}/customers/${id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data
    })

    if (response instanceof Error) {
      return { error: response }
    }

    return response
  } catch (error) {
    // Sentry TODO
    return { error }
  }
}
